import { render } from "./TaskSearchPopup.vue?vue&type=template&id=6d5df855&scoped=true"
import script from "./TaskSearchPopup.vue?vue&type=script&lang=js"
export * from "./TaskSearchPopup.vue?vue&type=script&lang=js"

import "./TaskSearchPopup.vue?vue&type=style&index=0&id=6d5df855&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5df855"]])

export default __exports__